<template>
  <div>
    <div class="anamnese-title">
      <span>5/5</span>
      <h4>{{ answers.five.name }}</h4>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>A. {{ answers.five.a.question }}</h4>
            <div
              v-if="answers.five.a.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.five.a.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.five.a.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('five', 'a', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.five.a.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('five', 'a', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.five.a.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>B. {{ answers.five.b.question }}</h4>
            <div
              v-if="answers.five.b.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.five.b.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.five.b.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('five', 'b', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.five.b.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('five', 'b', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.five.b.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>C. {{ answers.five.c.question }}</h4>
            <div
              v-if="answers.five.c.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.five.c.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.five.c.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('five', 'c', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.five.c.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('five', 'c', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.five.c.explanation"
      ></textarea>
    </div>
  </div>
</template>

<script>
import useAnswers from "../../composables/useAnswers.js";

export default {
  components: {},
  setup() {
    const { answers } = useAnswers();

    const onClickBoolean = (question, letter, answer) => {
      if (answers.value[question][letter].answer == answer) {
        answers.value[question][letter].answer = "";
      } else {
        answers.value[question][letter].answer = answer;
      }
    };

    return { answers, onClickBoolean };
  },
};
</script>

<style scoped>
@media (min-width: 991px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 225px;
  }
}
@media (min-width: 1442px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 300px;
  }
}
</style>
